import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationService, Toast } from '../../services/notification.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="toast-container">
      <div *ngFor="let toast of toasts" class="toast" [ngClass]="toast.type" (click)="dismiss(toast.id)">
        <span class="toast-icon">{{ getIcon(toast.type) }}</span>
        <span class="toast-msg" [innerText]="toast.message"></span>
      </div>
    </div>
  `,
  styles: [`
    .toast-container { position: fixed; top: 70px; right: 20px; z-index: 9999; display: flex; flex-direction: column; gap: 8px; max-width: 420px; }
    .toast { display: flex; align-items: flex-start; gap: 10px; padding: 14px 18px; border-radius: 6px; box-shadow: 0 4px 16px rgba(0,0,0,0.15); cursor: pointer; animation: slideIn 0.3s ease; font-size: 13px; line-height: 1.4; }
    .toast.success { background: #e8f5e9; border-left: 4px solid #4caf50; color: #2e7d32; }
    .toast.error { background: #fbe9e7; border-left: 4px solid #d32f2f; color: #c62828; }
    .toast.warning { background: #fff8e1; border-left: 4px solid #ff8f00; color: #e65100; }
    .toast-icon { font-size: 16px; flex-shrink: 0; }
    .toast-msg { flex: 1; white-space: pre-line; }
    @keyframes slideIn { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }
  `]
})
export class ToastComponent {
  toasts: Toast[] = [];

  constructor(private notifications: NotificationService) {
    this.notifications.toasts$.subscribe(t => this.toasts = t);
  }

  dismiss(id: number) { this.notifications.dismiss(id); }

  getIcon(type: string): string {
    switch (type) {
      case 'success': return '\u2713';
      case 'error': return '\u2717';
      case 'warning': return '\u26A0';
      default: return '';
    }
  }
}
